<div
  matRipple
  class="heart"
  [class.active]="liked"
  (click)="toggle()"
  [matTooltip]="liked ? 'Удалить из избранного' : 'Добавить в избранное'"
  matTooltipPosition="above"
  matTooltipShowDelay="500"
></div>
